import React from "react";
import './ShareholdingPattern.css'

import useMeta from '../../../hooks/useMeta'

import { Link } from "react-router-dom";

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";
import { FaOtter } from "react-icons/fa";

const ShareHolding_Pattern = () => {

    useMeta({
        title: 'Shareholding Pattern | Marvel Blinds',
        description: "Share holding Pattern as on 31.03.2025 Share holding Pattern as on 30.09.2024 Share holding Pattern as on 31.03.2024 Share holding Pattern as on 30.09.2023 Share holding Pattern as on 31.03.2023 Share holding Pattern as on 30.09.2022 Share holding Pattern as on 31.03.2022 Share holding Pattern as on 30.09.2021 Share holding Pattern as on 31.03.2021 Share […]",
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/shareholding-pattern`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Shareholding Pattern',
            description:
                "Share holding Pattern as on 31.03.2025 Share holding Pattern as on 30.09.2024 Share holding Pattern as on 31.03.2024 Share holding Pattern as on 30.09.2023 Share holding Pattern as on 31.03.2023 Share holding Pattern as on 30.09.2022 Share holding Pattern as on 31.03.2022 Share holding Pattern as on 30.09.2021 Share holding Pattern as on 31.03.2021 Share […]",
            url: `${process.env.REACT_APP_WEBSITE_URL}/shareholding-pattern`,
            site_name: 'Marvel Blinds',
        },
    });


    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="SHP-pg-container">
                <h2 className="SHP-pg-title">SHAREHOLDING PATTERN</h2>
                <table className="SHP-pg-content-table">
                    <tbody>
                        <tr>
                            <td className="even-row ">
                                <Link target="__blank" to="/HTML/Report_MDL_19042025.html">
                                    Share holding Pattern as on 31.03.2025
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/HTML/Report_MDL_15102024.html">
                                    Share holding Pattern as on 30.09.2024
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/Share_holding_Pattern_as_on31.03.2024.pdf">
                                    Share holding Pattern as on 31.03.2024
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/Documnets/Share-holding-Pattern30.09.2023.pdf">
                                    Share holding Pattern as on 30.09.2023
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/Share holding Pattern as on 31.03.2023.pdf">
                                    Share holding Pattern as on 31.03.2023
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/Documnets/Share holding Pattern as on 30.09.2022.pdf">
                                    Share holding Pattern as on 30.09.2022
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/share-holding-pattern-as-on-31.03.2022.pdf">
                                    Share holding Pattern as on 31.03.2022
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/Documnets/share-holding-pattern-as-on-30.09.2021.pdf">
                                    Share holding Pattern as on 30.09.2021
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/share-holding-pattern-as-on-31.03.2021.pdf">
                                    Share holding Pattern as on 31.03.2021
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/Documnets/share-holding-pattern-as-on-30.09.2020.pdf">
                                    Share holding Pattern as on 30.09.2020
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/share-holding-pattern-as-on-31.03.2020.pdf">
                                    Share holding Pattern as on 31.03.2020
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="Border-none">
                                <Link target="__blank" to="/Documnets/share-holding-pattern-as-on-30.09.2019.pdf">
                                    Share holding Pattern as on 30.09.2019
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="even-row">
                                <Link target="__blank" to="/Documnets/share-holding-pattern-as-on-31.03.2019.pdf">
                                    Share holding Pattern as on 31.03.2019
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="border-top-none">
                                <Link target="__blank" to="/Documnets/share-holding-pattern-as-on-31.03.2018.pdf">
                                    Share holding Pattern as on 31.03.2018
                                </Link>
                            </td>
                        </tr>
                        <tr>
                            <td className="border-top-none">
                                <Link target="__blank" to="/Documnets/share-holding-pattern-as-on-22.02.2018.pdf">
                                    Share holding Pattern as on 22.02.2018
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}

export default ShareHolding_Pattern;    